import { Modal} from "react-bootstrap";
import { UserForm } from "../Form/UserForm";
import { modalPreferencesTherapistText } from "../../lib/constants";
import Alert from "react-bootstrap/Alert";
import { getTherapist } from "../../service/therapits-service";
import { user } from "../utils/auth";
import { useState, useEffect } from "react";

export const ModalPreferencesTherapist = ({ modal, handleClose }) => {
    const [initialValues, setInitialValues] = useState(null);

    const fetchTherapistData = async () => {
        try {
            const userData = user();
            const data = await getTherapist(userData?.uid);
            setInitialValues({
                qualified_to_assist: data?.qualified_to_assist || false,
                availability: data?.availability || "",
                accepted_terms: data?.accepted_terms || false,
            });
        } catch (error) {
            setInitialValues({
                qualified_to_assist: false,
                availability: "",
                accepted_terms: false,
            });
        } 
    };

    useEffect(() => {
        if (modal) {
            fetchTherapistData();
        }
    }, [modal]);

    return (
    modal && (
        <div>
            <Modal show={modal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalPreferencesTherapistText.modal_title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>
                    {modalPreferencesTherapistText.how_to_be_angel}
                    <br />
                    {modalPreferencesTherapistText.to_be_a_ward}
                    </p>

                    <Alert variant="info">
                    {modalPreferencesTherapistText.modal_mark_as_available}
                    </Alert>
                    <UserForm initialValues={initialValues} />
                </Modal.Body>
            </Modal>
        </div>
    ));
};